import React from "react";

const SEOResult = () => {
  return (
    <div className="py-[3%] px-[6%]">
      <div className="text-[2.5rem] mb-[0.5rem] pb-[3%]  text-center font-[500] leading-[1.2]">
        <b> Clients Latest SEO Results</b>
      </div>
      <div className="relative mb-[5%]">
        <div className="w-full h-2 border-b border-[#bbb]"></div>
        <div className="absolute top-0 left-1/2 transform -translate-x-1/2 flex items-center justify-center w-10 h-4">
          <div className="w-12 h-4 bg-white rounded-full">
            <div className="h-12 w-12  mt-[-60px]  border-b-2 bg-rekd-500 border-[#bbb] rounded-full">
              {/* <div className="h-6 w-6 bg-[#4e413a] rounded-full ml-[10px] mt-[40px] "> */}
              <img
                src="/Images/circle.png"
                alt=""
                className="object-cover mt-[40px]"
              />
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
      <div className=" grid md:grid-cols-2 grid-cols-1 gap-10">
        <table className="shadow-2xl m-2">
          <thead className="border-[2px] ">
            <tr className="h-[80px]">
              <img
                src="/Images/gla11.png"
                alt=""
                className=" lg:text-center object-cover lg:mx-[30%] lg:w-[40%] lg:my-[4%]"
              />
            </tr>
            <tr className="bg-[#fbcc0d] mt-1 px-10 text-white text-[20px] uppercase  h-14">
              <td className="text-white font-heading font-bold text-xl uppercase px-5">
                Ranking on India
              </td>
              <td></td>
            </tr>
          </thead>
          <tbody className="font-[400] leading-[1.5] border-[2px] bg-white px-4 py-2">
            <tr className=" border-[2px] h-12">
              <td className="py-2 px-4">Legal Conference </td>
              <td className="py-2 pl-10 pr-4">#4</td>
            </tr>
            <tr className=" border-[2px] h-12">
              <td className="py-2 px-4">Dubai Legal Conference </td>
              <td className="py-2 pl-10 pr-4">#2</td>
            </tr>
            <tr className=" border-[2px] h-12">
              <td className="py-2 px-4">Annual conference Dubai </td>
              <td className="py-2 pl-10 pr-4">#8</td>
            </tr>
            <tr className=" border-[2px] h-12">
              <td className="py-2 px-4">Legal Association </td>
              <td className="py-2 pl-10 pr-4">#5</td>
            </tr>
            <tr className=" border-[2px] h-12">
              <td className="py-2 px-4">Annual conference Dubai 2023 </td>
              <td className="py-2 pl-10 pr-4">#1</td>
            </tr>
            <tr className=" border-[2px] h-12">
              <td className="pt-2 pb-20 px-4">Global Legal 2023 </td>
              <td className="pt-2 pb-20 pl-10 pr-4">#3</td>
            </tr>
          </tbody>
        </table>
        <table className="shadow-2xl m-2">
          <thead className="border-[2px] ">
            <tr className="h-[80px]">
              <img
                src="/Images/cvs11.png"
                alt=""
                className=" lg:text-center object-cover lg:mx-[30%] lg:w-[40%] lg:my-[4%]"
              />
            </tr>
            <tr className="bg-[#fbcc0d] mt-1 px-10 text-white text-[20px] uppercase  h-14">
              <td className="text-white font-heading font-bold text-xl uppercase px-5">
                Ranking on India
              </td>
              <td></td>
            </tr>
          </thead>
          <tbody className="font-[400] leading-[1.5] border-[2px] bg-white px-4 py-2">
            <tr className=" border-[2px] h-12">
              <td className="py-2 px-4">Tally on Cloud </td>
              <td className="py-2 pl-10 pr-4">#4</td>
            </tr>
            <tr className=" border-[2px] h-12">
              <td className="py-2 px-4">Tally Integration </td>
              <td className="py-2 pl-10 pr-4">#8</td>
            </tr>
            <tr className=" border-[2px] h-12">
              <td className="py-2 px-4">Tally product and services </td>
              <td className="py-2 pl-10 pr-4">#12</td>
            </tr>
            <tr className=" border-[2px] h-12">
              <td className="py-2 px-4">Cloud and AWS service </td>
              <td className="py-2 pl-10 pr-4">#17</td>
            </tr>
            <tr className=" border-[2px] h-12">
              <td className="py-2 px-4">Tally Customization </td>
              <td className="py-2 pl-10 pr-4">#9</td>
            </tr>
            <tr className=" border-[2px] h-12">
              <td className="pt-2 pb-20 px-4">Tally business solution</td>
              <td className="pt-2 pb-20 pl-10 pr-4">#5</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SEOResult;
